/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'app/components/common/Loading.jsx';
import CurationInputItem from 'app/components/RouteList/CurationInputItem.jsx';
import * as _ from 'underscore';

class CurationInputListItems extends React.Component {
    constructor(props) {
        super(props);

        let inputId = null;

        if (this.props.router.params && this.props.router.params.inputId) {
            inputId = this.props.router.params.inputId;
        }

        this.state = {
            detailId: 0
        };

        this.deleteInput = this.deleteInput.bind(this);
        this.detailHandler = this.detailHandler.bind(this);
        this.refreshFeed = this.refreshFeed.bind(this);

    }

    componentDidMount() {

        let inputId = 0;

        if (this.props.router.params && this.props.router.params.inputId) {
            inputId = this.props.router.params.inputId;
        }

        if (this.props.router.query !== null && this.props.router.query.state && this.props.router.query.state.match(/REAUTH/)) {
            this.props.authReturnHandler({
                path: '/share/curate/feeds/list',
            }, (input) => {
                if (input) {
                    this.props.updateCurationInput(input);
                }
                this.props.resetAuthState();
            });
        }

        if (inputId) {
            this.props.getCurationInput(inputId);
            this.setState({
                detailId: inputId
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (_.isEmpty(prevProps.curation.route) && !_.isEmpty(this.props.curation.route)) {
            if (this.state.detailId) {
                this.props.getCurationInput(this.state.detailId);
            }
        }

    }

    deleteInput(id) {

        this.props.deleteCurationInput(id);

    }

    detailHandler(e) {

        let detailId = e.currentTarget.getAttribute('data-id');

        e.preventDefault();

        //second click on row closes the detail
        if (detailId === this.state.detailId) {
            this.props.deleteMessage(['INPUT_REFRESH', 'INPUT_UPDATE']);
            this.props.router.navigate('/share/curate/feeds/list');
            detailId = 0;
        } else {
            this.props.deleteMessage(['INPUT_REFRESH', 'INPUT_UPDATE']);
            this.props.getCurationInput(detailId);
            this.props.router.navigate('/share/curate/feeds/detail/' + detailId);
        }

        this.setState({
            detailId
        });

    }

    refreshFeed(e) {

        let routeId = this.props.route.id,
            inputId = e.currentTarget.dataset.id;

        this.props.refreshInput(inputId);

    }

    render() {

        let inputs = this.props.route.inputs ? this.props.route.inputs : [];

        if (this.props.app.loading.CURATION_LIST) {
            return (
                <Loading/>
            );
        }


        return (
            <ul className="dlvr-feed-list">
				{ inputs.map((input) => {
                    let showDetail = (input.id == this.state.detailId) ? true : false;

                    return (
                        <CurationInputItem
                            {...this.props}
        					key={input.id}
                            route={this.props.route}
        					input={input}
        					deleteMethod={this.deleteInput}
        					detailHandler={this.detailHandler}
        					showDetail={showDetail}
        					refreshFeed={this.refreshFeed}
        					socials={this.props.socials} />
                    );
                }) }
			</ul>
        );

    }
};

CurationInputListItems.displayName = "CurationInputListItems";

CurationInputListItems.propTypes = {
    recordPath: PropTypes.func,
};

CurationInputListItems.defaultProps = {
    recordPath: () => {}
};

export default CurationInputListItems;
